import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown, MenuProps } from "antd";
import { useRouter } from "next/router";

export const ProgramNavBar: React.FC = () => {
  const router = useRouter();

  const items: MenuProps["items"] = [
    {
      key: "LMS",
      label: (
        <a
          href="/lms"
          target="_blank"
          rel="noopener noreferrer"
          className={
            router.pathname === "/lms" ? "text-accelist-green" : "text-black"
          }
        >
          Learning Management System
        </a>
      ),
    },
    {
      key: "BNSP",
      label: (
        <a
          href="/program/bnsp"
          target="_blank"
          rel="noopener noreferrer"
          className={
            router.pathname === "/program/bnsp"
              ? "text-accelist-green"
              : "text-black"
          }
        >
          Pelatihan Perusahaan dan Uji BNSP
        </a>
      ),
    },
    {
      key: "bootcamp",
      label: (
        <a
          href="/program/bootcamp"
          target="_blank"
          rel="noopener noreferrer"
          className={
            router.pathname === "/program/bootcamp"
              ? "text-accelist-green"
              : "text-black"
          }
        >
          {/* Bootcamp Umum Intensif Terakreditasi */}
          Bootcamp Terakreditasi Kemnaker
        </a>
      ),
    },
    {
      key: "ekstrakulikuler",
      label: (
        <a
          href="/ekskul"
          target="_blank"
          rel="noopener noreferrer"
          className={
            router.pathname === "/ekskul" ? "text-accelist-green" : "text-black"
          }
        >
          Ekstrakulikuler tingkat SD, SMP, SMA
        </a>
      ),
    },
  ];

  return (
    <Dropdown
      className={`block duration-300 lg:p-2 lg:mx-4 hover:text-black 
        ${router.pathname.startsWith("/lms") ||
          router.pathname.startsWith("/program/workshop") ||
          router.pathname.startsWith("/program/bootcamp") ||
          router.pathname.startsWith("/ekskul")
          ? "text-accelist-green"
          : "text-black"
        }`}
      menu={{ items }}
    >
      <a
        onClick={(e) => {
          e.preventDefault();
          router.push("/#program-type");
        }}
      >
        Program
        <FontAwesomeIcon icon={faChevronDown} className="ml-2" />
      </a>
    </Dropdown>
  );
};
